<template>
  <div class="maintenance-modal">
    <div class="flex flex-col items-center">
      <EpIconButton
        icon-name="clear"
        icon-size="24"
        class="ml-auto"
        @click="handleClose"
      />
      <img
        src="https://globalstatic.xangle.io/explorer/aptos/maintenance.png"
        alt="maintenance"
        class="h-1/2 w-1/2"
      >	
      <div class="flex flex-col gap-y-2">
        <p class="mobile:text-xl text-[24px] font-bold">
          {{ translate('inspection.scheduled-title') }}
        </p>
        <p
          class="text-default/80 mobile:text-sm"
          v-html="translate('inspection.scheduled-description')"
        /> 
      </div>
    </div>
    <div class="bg-default/10 flex w-full flex-col gap-y-2 rounded-lg p-6">
      <p class="text-primary mobile:text-xl text-xl font-bold">
        {{ translate('inspection.maintenancePeriod') }}
      </p>
      <p class="mobile:text-sm font-bold">
        {{ translate('inspection.kstDate') }}
        <br>
        {{ translate('inspection.utcDate') }}
      </p>
      <p class="text-fail text-sm">
        {{ translate('inspection.maintenanceDescription') }}
      </p>
    </div>
    <div class="flex flex-col gap-y-4 text-base">
      <button
        @click.stop="handleClose"
        class="text-default bg-primary w-60 rounded-none p-2 text-sm font-normal"
      >
        Close
      </button>
      <button
        class="text-default p-2 text-sm underline"
        @click.stop="onDontShowToday"
      >
        Don't show again today
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import EpIconButton from '../button/EpIconButton.vue'

const { onDialogClose } = useGlobalDialog()
const { setHiddenUntilTomorrow } = useMaintenanceModal()
const { translate } = useTranslator()

const handleClose = () => {
  onDialogClose() // 모달 닫기
}

const onDontShowToday = async () => {
  await setHiddenUntilTomorrow() // 로컬스토리지 저장 완료까지 대기
  onDialogClose() // 모달 닫기
}
</script>

<style lang="scss" scoped>
.maintenance-modal {
  @apply relative border border-default/20 shadow-[0px_16px_32px_0px] shadow-default/20 bg-black flex flex-col items-center gap-y-8 mobile:gap-y-6 text-center p-6 mobile:p-4 rounded-lg w-[500px] mobile:w-[calc(100%-2rem)] mx-auto;

  &::before {
    @apply absolute top-0 left-0 w-full h-full rounded-2xl z-[-1];
    content: "";

    backdrop-filter: blur(40px);
  }
}

</style>